/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/components/snippets/pre-sale-policy-popup/pre-sale-policy-popup.js":
/*!********************************************************************************!*\
  !*** ./src/components/snippets/pre-sale-policy-popup/pre-sale-policy-popup.js ***!
  \********************************************************************************/
/***/ (() => {

eval("$(document).ready(function () {\n  window.openPreSalePolicy = function () {\n    window.dialogCount = window.dialogCount || 0;\n    window.dialogCount += 1;\n    $('body').css('overflow', 'hidden');\n    $('.pre-sale-policy-popup').css('display', 'flex');\n  };\n  $('body').on('click', '.pre-sale-policy-popup .pre-sale-policy__close', function () {\n    window.dialogCount -= 1;\n    if (window.dialogCount == 0) {\n      $('body').css('overflow', '');\n    }\n    $('.pre-sale-policy-popup').css('display', 'none');\n  });\n  $('body').on('click', '.pre-sale-header__tip-icon', openPreSalePolicy);\n});\n\n//# sourceURL=webpack://webpack-shopify-cli/./src/components/snippets/pre-sale-policy-popup/pre-sale-policy-popup.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/components/snippets/pre-sale-policy-popup/pre-sale-policy-popup.js"]();
/******/ 	
/******/ })()
;